<!--cookie弹窗-->
<template>
  <transition name="fade">
    <div class="cookie" v-if="isShow">
      <el-row align="middle" type="flex">
        <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
          <div>
            <p class="name">{{ $t("bottom-cookie-title") }}</p>
            <p class="content">
              {{ $t("bottom-cookie-content") }}
            </p>
          </div>
        </el-col>

        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="cookie-btn-array">
            <el-button @click="handleAgree" class="cookie-btn bold">{{
              $t("bottom-cookie-accept")
            }}</el-button>
            <el-button @click="handleReject" class="cookie-btn-reject bold">{{
              $t("bottom-cookie-reject")
            }}</el-button>
            <p
              class="bottom-cookie-des"
              @click="$router.push('/cookieSetting')"
            >
              {{ $t("bottom-cookie-des") }}
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
  </transition>
</template>

<script>
import { setCookie, getCookie } from "@/utils/index.js";
export default {
  name: "cookie",
  data() {
    return {
      isShow: false,
      cookieName: "CHANG_CHENG_COOKIE",
    };
  },
  created() {
    // if (!localStorage.getItem(this.cookieName)) {
    //   this.isShow = true;
    // }
    console.warn(!getCookie(this.cookieName));
    if (getCookie(this.cookieName) == "true") {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  methods: {
    handleAgree() {
      this.isShow = false;
      // localStorage.setItem(this.cookieName, true);
      setCookie(this.cookieName, true);
    },
    handleReject() {
      this.isShow = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.cookie {
  background: #fff;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 3;
  box-sizing: border-box;
  color: #000;
  // box-shadow: 3px -5px 9px rgb(89 88 88 / 13%);
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  text-align: left;
  padding: 20px 100px;
  .bottom-cookie-des {
    width: 190px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    text-decoration-line: underline;
    color: #555555;
    font-family: "NexaBold";
    cursor: pointer;
  }
  .cookie-btn-array {
    display: flex;
    flex-direction: column;
    align-items: center;
    .cookie-btn {
      width: 230px !important;
      border-radius: 100px !important;
      font-size: 12px !important;
      margin: 0 !important;
    }
    .cookie-btn-reject {
      width: 230px !important;
      border: 1px solid #000;
      border-radius: 100px !important;
      font-size: 12px !important;
      background: #fff !important;
      color: #000 !important;
      // margin: 0 !important;
      margin: 15px 0 !important;
    }
  }

  @media (max-width: 767px) {
    padding: 20px 28px 40px;
    .bottom-cookie-des {
      width: 100%;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      text-decoration-line: underline;
      color: #555555;
      font-family: "NexaBold";
    }
    .cookie-btn-array {
      display: flex;
      flex-direction: column;
      align-items: center;
      .cookie-btn {
        width: 100% !important;
        border-radius: 100px !important;
        font-size: 12px !important;
        margin: 20px 0 0 0 !important;
      }
      .cookie-btn-reject {
        width: 100% !important;
        border: 1px solid #000;
        border-radius: 100px !important;
        font-size: 12px !important;
        background: #fff !important;
        color: #000 !important;
        // margin: 0 !important;
        margin: 15px 0 !important;
      }
    }
  }
  .el-row {
    flex-wrap: wrap;
  }
  .name {
    font-size: 20px;
    // font-weight: 700;
    font-family: "NexaBold";
  }
  .content {
    font-size: 12px;
    line-height: 19px;
    letter-spacing: 0.025em;
    color: #000000;
    margin-top: 20px;
  }

  .el-col:last-child {
    text-align: center;
    .el-button {
      background: #13b0b9;
      color: #fff;
      border-radius: 0;
      padding: 14px 50px;
      @media (max-width: 767px) {
        margin-top: 40px;
        width: 100%;
      }
    }
    // p {
    //   color: #3f5864;
    //   font-size: 12px;
    //   // text-decoration: underline;
    //   cursor: pointer;
    //   margin-top: 24px;
    // }
  }
  .el-checkbox {
    color: #fff;

    ::v-deep .el-checkbox__label {
      color: #fff !important;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: transform 0.5s;
}

.fade-enter,
.fade-leave-to {
  transform: translateY(100%);
}
</style>